export const messages = {
  en: {
    'general.unavailable': 'Something went wrong. Please try again.',
    'request.bad': 'The request could not be processed.',
    'request.forbidden': 'You do not have permission to do this.',
    'request.method_not_allowed': 'This action is not available.',
    'request.not_found': 'The requested item could not be found.',
    'request.rate_limited': 'Too many requests. Please try again shortly.',
    'request.validation_failed': 'Check the entered information and try again.',
    'auth.unauthenticated': 'Your session has expired. Please log in again.',
    'auth.invalid_credentials': 'The email address or password is incorrect.',
    'tenant.context_missing': 'This service is temporarily unavailable.',
    'tenant.not_found': 'This service is temporarily unavailable.',
    'payment.failed': 'The payment could not be completed. Please try again.',
    'payment.insufficient_funds': 'You do not have enough credits.',
    'payment.not_found': 'The payment could not be found.',
    'subscription.failed': 'The subscription could not be updated. Please try again.',
    'subscription.not_found': 'The subscription could not be found.',
    'chat.conversation_not_found': 'The conversation could not be found.',
    'chat.live_session_unavailable': 'The live session is not available right now.',
    'chat.conversation_billing_exempt': 'This conversation is free and cannot be switched to paid.',
    'chat.office_chat_not_allowed': 'Office chat is not available for this account.',
    'chat.office_chat_followers_only': 'The agency can only message customers who follow it.',
    'chat.profile_cards_invalid': 'One or more selected ladies can no longer be suggested. Please choose again.',
    'operator.masquerade_session_active': 'This profile is currently in a session with another operator.',
    'operator.escort_not_found': 'This profile could not be found or is not accessible.',
    'operator.masquerade_not_allowed': 'You are not allowed to start a session for this profile.',
    'operator.escort_not_assigned': 'This profile is not in your assignment roster.',
    'verification.disabled': 'Verification is not available right now.',
    'verification.expired': 'This verification request has expired.',
    'verification.forbidden': 'You cannot access this verification request.',
    'verification.init_failed': 'Verification could not be started. Please try again.',
    'verification.invalid_requirements': 'This verification request is invalid.',
    'verification.location_unavailable': 'Your location could not be determined.',
    'verification.not_found': 'The verification request could not be found.',
    'verification.payment_required': 'You do not have enough credits to start verification.',
    'verification.unsupported_type': 'This verification type is not supported.',
    'status.online': 'Online',
    'status.offline': 'Offline',
    'status.recently_online': 'Recently online',
    'status.pending': 'Pending',
    'status.processing': 'Processing',
    'status.approved': 'Approved',
    'status.rejected': 'Rejected',
    'status.failed': 'Failed',
    'status.canceled': 'Canceled',
    'status.cancelled': 'Canceled',
    'status.expired': 'Expired',
    'status.paid': 'Paid',
    'status.completed': 'Completed',
    'status.active': 'Active',
  },
  nl: {
    'general.unavailable': 'Er is iets misgegaan. Probeer het opnieuw.',
    'request.bad': 'De aanvraag kon niet worden verwerkt.',
    'request.forbidden': 'Je hebt geen toestemming om dit te doen.',
    'request.method_not_allowed': 'Deze actie is niet beschikbaar.',
    'request.not_found': 'Het gevraagde item kon niet worden gevonden.',
    'request.rate_limited': 'Te veel aanvragen. Probeer het over een moment opnieuw.',
    'request.validation_failed': 'Controleer de ingevulde gegevens en probeer het opnieuw.',
    'auth.unauthenticated': 'Je sessie is verlopen. Log opnieuw in.',
    'auth.invalid_credentials': 'Het e-mailadres of wachtwoord is onjuist.',
    'tenant.context_missing': 'Deze dienst is tijdelijk niet beschikbaar.',
    'tenant.not_found': 'Deze dienst is tijdelijk niet beschikbaar.',
    'payment.failed': 'De betaling kon niet worden voltooid. Probeer het opnieuw.',
    'payment.insufficient_funds': 'Je hebt niet genoeg credits.',
    'payment.not_found': 'De betaling kon niet worden gevonden.',
    'subscription.failed': 'Het abonnement kon niet worden bijgewerkt. Probeer het opnieuw.',
    'subscription.not_found': 'Het abonnement kon niet worden gevonden.',
    'chat.conversation_not_found': 'Het gesprek kon niet worden gevonden.',
    'chat.live_session_unavailable': 'De live-sessie is nu niet beschikbaar.',
    'chat.conversation_billing_exempt': 'Dit gesprek is gratis en kan niet betaald worden gemaakt.',
    'chat.office_chat_not_allowed': 'Chatten met het bureau is niet beschikbaar voor dit account.',
    'chat.office_chat_followers_only': 'Het bureau kan alleen klanten berichten die het bureau volgen.',
    'chat.profile_cards_invalid': 'Een of meer gekozen dames kunnen niet meer worden voorgesteld. Kies opnieuw.',
    'operator.masquerade_session_active': 'Dit profiel wordt op dit moment gebruikt door een andere operator.',
    'operator.escort_not_found': 'Dit profiel kon niet worden gevonden of is niet toegankelijk.',
    'operator.masquerade_not_allowed': 'Je mag geen sessie starten voor dit profiel.',
    'operator.escort_not_assigned': 'Dit profiel staat niet in jouw toegewezen rooster.',
    'verification.disabled': 'Verificatie is nu niet beschikbaar.',
    'verification.expired': 'Dit verificatieverzoek is verlopen.',
    'verification.forbidden': 'Je hebt geen toegang tot dit verificatieverzoek.',
    'verification.init_failed': 'De verificatie kon niet worden gestart. Probeer het opnieuw.',
    'verification.invalid_requirements': 'Dit verificatieverzoek is ongeldig.',
    'verification.location_unavailable': 'Je locatie kon niet worden bepaald.',
    'verification.not_found': 'Het verificatieverzoek kon niet worden gevonden.',
    'verification.payment_required': 'Je hebt niet genoeg credits om de verificatie te starten.',
    'verification.unsupported_type': 'Dit verificatietype wordt niet ondersteund.',
    'status.online': 'Online',
    'status.offline': 'Offline',
    'status.recently_online': 'Onlangs online',
    'status.pending': 'In behandeling',
    'status.processing': 'Wordt verwerkt',
    'status.approved': 'Goedgekeurd',
    'status.rejected': 'Afgewezen',
    'status.failed': 'Mislukt',
    'status.canceled': 'Geannuleerd',
    'status.cancelled': 'Geannuleerd',
    'status.expired': 'Verlopen',
    'status.paid': 'Betaald',
    'status.completed': 'Voltooid',
    'status.active': 'Actief',
  },
};
